import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useEventEngineStateStore = defineStore('eventEngineStateStore', () => {
    const eventEngineStates = ref({});

    function addEventEngineState(eventEngineStateModel) {
        eventEngineStates.value[eventEngineStateModel.id] = eventEngineStateModel;
    }

    function updateEventEngineState(id, eventEngineStateModel) {
        eventEngineStates.value[id] = eventEngineStateModel;
    }

    function removeEventEngineState(id) {
        delete eventEngineStates.value[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(eventEngineStates.value[id], jsonPatch, false, true);
    }

    return {
        eventEngineStates,
        addEventEngineState,
        updateEventEngineState,
        removeEventEngineState,
        applyJsonPatch
    }
})